<template>
  <el-menu-item style="float:right">
    <a :href="vosLink" target="_blank">
      <el-tag type="primary" size="normal" plain>
        <i class="el-icon-plus text-info p-0 m-0" style="position: relative;left:0;top:-2px;"></i> Recharge
      </el-tag>
    </a>
    <a>
      <el-tag :type="(userVOSBalance > 0)? 'success' : 'danger'" size="normal"  v-if="userVOSBalance" plain>
        <i class="el-icon-money" :class="(userVOSBalance > 0)? 'text-success' : 'text-danger'"></i> Balance:  {{userVOSBalance}}
      </el-tag>
    </a>
    <a>
      <el-tag :type="(userVOSBalance > 0)? 'info' : 'info'" size="normal"  v-if="userVOSBalance" plain>
        <i class="el-icon-stopwatch"></i> Overdraft: {{userVOSOverdraft}}
      </el-tag>
    </a>
  </el-menu-item>
</template>

<script>


export default {
  props: {
    userVOSBalance: {
      required: false,
      default: false
    },
    userVOSOverdraft: {
      required: false,
      default: false
    }
  },
  mounted() {
    this.getResellerFields({id: this.userId}).then( (r) => {
      this.vosLink = r.data.vos_recharge_link
    })
  },
  methods: {
    ...$mapActions('user-reseller-features-api', {
      prepareNewResellerFields: 'create',
      getResellerFields: 'get',
      updateResellerFields: 'update'
    }),
  },
  data () {
    return {
      userId: $store.state['user-state'].profile.id,
      vosLink: null
    }
  }
}
</script>
